import { createFileRoute } from "@tanstack/react-router";
import { KbTermEditPage } from "@client/components/kb/settings/kb-term-edit-page";

export const Route = createFileRoute("/_app/kb/$kbId/settings/terms/edit/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId, id } = Route.useParams();
  return <KbTermEditPage kbId={kbId} id={id} />;
}
